export function usePage() {
  function checkIsJoinUsPage() {
    return location.href.includes('join-us')
  }

  return {
    checkIsJoinUsPage
  }
}
